import React, { FC, useCallback, useContext } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import set from 'lodash/set';
// @ts-ignore
import 'react-datepicker/dist/react-datepicker.css';

import ADDatePicker from '@ad-scripts/presentation/components/common/datetime/date_picker';
import { FieldContainer } from 'src/presentation/components/pages/shared/HoursTable/TimeRange';
import FormContext from 'src/presentation/contexts/FormContext';
import getErrorMessage from 'src/presentation/components/forms/getErrorMessage';

export type DatePickerProps = {
  attr: string;
  className?: string;
  'data-aid'?: string;
  description?: string;
  disabled?: boolean;
  label?: string;
  onChange?: Function;
  placeholder?: string;
  readOnly?: boolean;
  value?: string;
};

const DatePicker: FC<DatePickerProps> = ({
  attr,
  className,
  'data-aid': dataAid,
  description,
  disabled,
  label,
  onChange,
  placeholder,
  readOnly,
  value,
}) => {
  const { errors, workingState, updateState, resetError } = useContext(FormContext);
  const error = find(errors, error => error.attr === attr);
  const workingVal = value || get(workingState, attr);

  const onDateChange = useCallback(
    value => {
      const formattedValue = Intl.DateTimeFormat('en-US').format(value);
      if (onChange) {
        onChange(formattedValue);
      } else {
        resetError({ attr, errors });
        updateState(set({}, attr, formattedValue));
      }
    },
    [attr, errors, onChange, resetError, updateState]
  );

  return (
    <FieldContainer
      className={'field-container'}
      data-aid={dataAid}
      description={description}
      error={error ? getErrorMessage(error, label) : undefined}
      label={label}
      control={
        <ADDatePicker
          className={className}
          data-aid={dataAid}
          disabled={disabled}
          isError={!!error}
          onChange={onDateChange}
          placeholder={placeholder}
          readOnly={readOnly}
          value={workingVal}
        />
      }
    />
  );
};

export default DatePicker;
